/** @file The arguments an analysis is sent with: empty values dropped, required fields still missing listed. */
import type { AutorigFn } from '@pose2d/api/autorig/autorigFns';
import { actionOf } from './actionOf';

/** Empty strings and empty arrays count as "not given" (the analysis default); `0` is a value. */
const given = (value: unknown): boolean => value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0);

/** Only the action's own keys survive; `missing` lists required keys without a value (Analyse stays disabled). */
export function readyArgs(fn: AutorigFn, form: Readonly<Record<string, unknown>>): { args: Record<string, unknown>; missing: string[] } {
  const args: Record<string, unknown> = {};
  const missing: string[] = [];
  for (const field of actionOf(fn).fields) {
    const value = form[field.key];
    if (given(value)) args[field.key] = value;
    else if (field.required) missing.push(field.key);
  }
  return { args, missing };
}
